import React, { Component, PureComponent } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form, actions } from 'react-redux-form';
import { Row, Col } from 'react-bootstrap';
import Translation from '../../../../common/translation/translation.component';
import { CIRCUIT_STATUS, PROPERTY_NAME as propName } from '../../../../../constants/external-constants';
import { CONFIRMATION_VALUE, TRANSLATIONS as translation } from '../../../../../utils/constant.utils';
import {
    ORFSelect, ORFButton
    , OR_RRF_Select as Select
    , ORFSearchSuggestions as SearchSuggestions
    , OR_RRF_TextArea as TextArea
} from '../../../../common/forms/order-request-form.component';
import { wirelessChangUserActions } from "./../../../../../store/external/request-reducer/order-request-reducer/wireless-request/wireless-change-user.reducer";
import { createRequestActions } from "./../../../../../store/external/request-reducer/create-request.reducer";
import { requestLogActions } from "./../../../../../store/external/request-reducer/request-log.reducer";
import './wireless-change-user.component.css';
import  store  from '../../../../../store';
import { NotificationModal } from '../../../../common/modal/notification-modal.component';
import { withRouter } from 'react-router-dom';
import { ConfirmationNotificationModal } from '../../../../common/modal/confirmation-modal.component';
import { Loading } from '../../../../common/loading/index';
import { MAX_LENGTH } from "../../../../../constants/external-constants";

class MobileChangeUserForm extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            businessCaseText: "",
            isSaving: false,
            showConModal: false,
            title: "",
            isLoading: true,
            error: false
        }
    }

    async componentDidMount() {
        const { isUpdateRequest, takeActionCircuitCode, takeActionCircuitId } = this.props.createRequest;
        const { requestDetail, fetchSubscriptionByRequestDetail, onLoadUpdateChangeUserRequest, setLoadForm, onSubscriptionSelect, fetchEmployeeByValue, fetchSubscriptionByValue } = this.props;
        var circuitCodePropName = 'CircuitCode';
        var subscriptionList = null;

        if (takeActionCircuitId != null || takeActionCircuitId !== undefined || takeActionCircuitCode) {
            
             subscriptionList = await fetchSubscriptionByValue(takeActionCircuitCode, circuitCodePropName);

            onSubscriptionSelect(takeActionCircuitCode, circuitCodePropName, subscriptionList, null, takeActionCircuitId);
        }
        else {
            onSubscriptionSelect('');
            if(takeActionCircuitId === undefined)
            {
               subscriptionList = await fetchSubscriptionByValue(null, circuitCodePropName);
            }
        }

        this.props.getListOfPurpose();
        this.props.getBusinessCase();

        if (isUpdateRequest) {
            const currentCircuitCode = requestDetail.requestData.Circuit.CircuitCode;            
            var circuitCodePropName = 'CircuitCode';
            setLoadForm(true);
            await fetchEmployeeByValue(requestDetail.requestData.NewRequest.User.LastFirstName, propName.Name)
            subscriptionList = await fetchSubscriptionByValue(currentCircuitCode, circuitCodePropName);
            await onLoadUpdateChangeUserRequest(subscriptionList, circuitCodePropName);
            setLoadForm(false);
        }
    }

    componentWillUnmount() {
        this.props.resetWirelessChangeUserForm();
        this.props.resetRequestData();
    }

    submitRequest = () => {
        this.setState({showConModal:true})
    }

    handleConfirmationModal = async (buttonType) => {
        if (buttonType === CONFIRMATION_VALUE.Ok) {
            const { submitRequest, fetchRequestLogItems } = this.props;
            this.setState( prev => ({
                isSaving:true,
            }))
            var success = await submitRequest();
            let resultMessage = success.Message;
            if (success.Success) {
                fetchRequestLogItems(0);
                this.setState({
                    title:"Success"
                });
                const { isUpdateRequest } = this.props.createRequest;
                resultMessage = isUpdateRequest ? this.toLocaleLanguage("order_has_been_updated") : this.toLocaleLanguage("order_has_been_submitted");
                this.props.hideRequestModal();
            }else {
                this.setState({
                    title:"Error"
                });
                resultMessage = success.Message ? success.Message : this.toLocaleLanguage("order_save_error_message");
            }
            this.setState( prev => ({
                showConModal: !prev.showConModal,
                show:true,
                isSaving:false,
                message: resultMessage,
            }));
        } else {
            this.setState({
                showConModal: false
            });
        }
    }

    handleCloseNotif = () => {
        this.setState({ show: false });
        if (this.state.title !== "Error") {
            this.props.history.goBack();
        }
    }

    onClickCancel = () => {
        const { modalClose } = this.props;

        if (modalClose) {
            modalClose();
        }
    }

    haveError = (value) => {
        this.setState({
            error: value
        })
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }
    businessCaseOnChange = (model, value) => {
        const { businessCaseOptions } = this.props.wirelessChangeUserRequest;
        const businessCaseText = businessCaseOptions.find((r) => r.Key == value)?.Value;
        const businessCaseId = businessCaseOptions.find((r) => r.Key == value)?.Key;
        this.setState({ businessCaseText: businessCaseText });

        const isOtherOption = businessCaseText === "Other";

        if (businessCaseText) {
            store.dispatch(actions.change("wirelessChangeUserFormA.busJustiCodeDetailId", businessCaseId));

            const businessJustificationInput = document.getElementById("wirelessChangeUserFormA.businessJustification"); 
            if (businessJustificationInput) {
                businessJustificationInput.disabled = isOtherOption;
            }

            if (!isOtherOption) {
                store.dispatch(actions.change("wirelessChangeUserFormA.businessJustification", businessCaseText));
            } else {
                store.dispatch(actions.change("wirelessChangeUserFormA.businessJustification", ""));
            }
        } else {
            store.dispatch(actions.change("wirelessChangeUserFormA.businessJustification", ""));
        }
    };

    render() {
        const { subscriptionList, employeeList, takeActionCircuitCode, isUpdateRequest, isRequestOnBehalf, requestOnBehalfData } = this.props.createRequest;
        const { changeUserRequestOptions, isFormLoading, isResetLoading } = this.props.wirelessChangeUserRequest;
        const { requestData } = this.props.requestDetail;
        const { wirelessChangeUserFormA, onSubscriptionSelect
            , onEmployeeSelect
            , fetchSubscriptionByValue
            , fetchEmployeeByValue } = this.props;
        const { formSubmitted, purposeOptions, businessCaseOptions, newUser, subscription } = this.props.wirelessChangeUserRequest;
        var circuitStatusName = isUpdateRequest && subscriptionList.length ? subscriptionList[0].CircuitStatus : subscription.CircuitStatus != null && subscription.CircuitStatus != "" ? subscription.CircuitStatus : "";

        const initialRequired = wirelessChangeUserFormA.circuitId == 0
            || wirelessChangeUserFormA.employeeId == 0
            || wirelessChangeUserFormA.purposeOfUseId == 0
            || wirelessChangeUserFormA.busJustiCodeDetailId == 0
            || wirelessChangeUserFormA.businessJustification == ''
            || (isRequestOnBehalf && !requestOnBehalfData.EmployeeId)
            || formSubmitted;
        const updateRequired = isUpdateRequest && !(requestData.Circuit.CircuitCode != wirelessChangeUserFormA.circuitCode
            || requestData.BusinessJustification.PurposeOfUseId != wirelessChangeUserFormA.purposeOfUseId
            || requestData.NewRequest.User.LastFirstName != wirelessChangeUserFormA.employeeEmail
            || requestData.BusinessJustification.BusJustiCodeDetailId != wirelessChangeUserFormA.busJustiCodeDetailId
            || requestData.BusinessJustification.BusinessJustification != wirelessChangeUserFormA.businessJustification
            || requestData.BusinessJustification.AdditionalInformation != wirelessChangeUserFormA.additionalInformation);

            return isFormLoading ?
            (<div>
                <Loading/>
            </div>) : (
            <div>
                    <NotificationModal
                        show={this.state.show}
                        title={this.state.title}
                        message={this.state.message}
                        handleModal={this.handleCloseNotif}
                        customClass={'comment-notification-modal notification-footer modal-text-bold'}
                    />
                    <ConfirmationNotificationModal
                        show={this.state.showConModal}
                        message={isUpdateRequest ? this.toLocaleLanguage("update_order_request_confirmation") : this.toLocaleLanguage("create_order_request_confirmation")}
                        title="Submit Form Request"
                        handleModal={this.handleConfirmationModal}
                        disabled={this.state.isSaving}
                        customClass={'comment-notification-modal modal-text-bold'}
                    />
                    <Form method="post" role="form"
                        model="wirelessChangeUserFormA"
                        onSubmit={this.submitRequest}
                    >
                        <Row className='search-suggestion'>
                            <Col className={`${wirelessChangeUserFormA.circuitCode !== '' ? '' : 'mb-4'} ${wirelessChangeUserFormA.changeUserRequestTypeId !== "23" && wirelessChangeUserFormA.changeUserRequestTypeId !== 23 ? 'required' : ""}`} xs={12} md={12} lg={12}>
                                {!isResetLoading &&
                                        <SearchSuggestions
                                            value={wirelessChangeUserFormA.circuitCode}
                                            label={`${this.toLocaleLanguage('mobile_phone_number')}`}
                                            propDisplay={'CircuitCode'}
                                            options={subscriptionList.length > 0 ? subscriptionList : ''}
                                            onChangeAction={onSubscriptionSelect}
                                            searchAction={fetchSubscriptionByValue}
                                            defaultValue={takeActionCircuitCode}
                                            placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                                            maxLength={MAX_LENGTH.limit_100}
                                            errorMessage={this.toLocaleLanguage('error_mobile_number_not_exist')}
                                            haveError={this.haveError}
                                        />
                                }                                
                            </Col>    
                            {wirelessChangeUserFormA.circuitCode != '' &&
                                <div className="pb-15-pl-30">
                                    <span className={circuitStatusName === CIRCUIT_STATUS.inService.name ? "status-inservice" : "status-suspended"}>{circuitStatusName} </span> <span>| </span>
                                    {isUpdateRequest && subscriptionList.length ? subscriptionList[0].VendorName : subscription.VendorName != null && subscription.VendorName != "" ? subscription.VendorName : ""} <span>| </span>
                                    {isUpdateRequest && subscriptionList.length ? (subscriptionList[0].PlanName != null && subscriptionList[0].PlanName != "" ? subscriptionList[0].PlanName : <Translation translationKey="no_plan_available" />) : subscription.PlanName != null && subscription.PlanName != "" ? subscription.PlanName : <Translation translationKey="no_plan_available" />} <span>| </span>
                                    {isUpdateRequest && subscriptionList.length ? (subscriptionList[0].DeviceName != null && subscriptionList[0].DeviceName != "" ? subscriptionList[0].DeviceName : <Translation translationKey="no_device_available" />) : subscription.DeviceName != null && subscription.DeviceName != '' ? subscription.DeviceName: <Translation translationKey="no_device_available" />}
                                </div>
                            }                       
                        </Row>
                        <div className='new-subscriber-container'>
                            <span className='text-field-title label-margin'><Translation translationKey="transfer_to" /></span>
                            <span className='text-field-title label-margin'><Translation translationKey="new_subscriber" /></span>
                        </div>
                        <Row className='search-suggestion'>
                            <Col xs={12} md={12} lg={12} className='required'>
                                {!isResetLoading &&
                                    <SearchSuggestions
                                        value={wirelessChangeUserFormA.employeeEmail}
                                        label={`${this.toLocaleLanguage('name')}`}
                                        placeholder={this.toLocaleLanguage('select_placeholder')}
                                        propDisplay={'LastFirstName'}
                                        options={employeeList.length > 0 ? employeeList : ''}
                                        onChangeAction={onEmployeeSelect}
                                        searchAction={fetchEmployeeByValue}
                                        disabled={wirelessChangeUserFormA.circuitId == 0}
                                        maxLength={MAX_LENGTH.limit_100}
                                    />
                                }
                            </Col>
                            <div className="approver-details">
                                {
                                    (newUser.EmailAddress || newUser.LocationSiteCityCountry) &&
                                    newUser.EmailAddress + " | " + newUser.LocationSiteCityCountry 
                                }

                            </div>
                        </Row>

                        <Row>
                            <Col xs={12} md={12} lg={12} className='required'>
                                <Select
                                    className="form-control"
                                    label={`${this.toLocaleLanguage('purpose_of_use')}`}
                                    options={purposeOptions}
                                    placeholder={this.toLocaleLanguage('select_placeholder')}
                                    fieldProp='.purposeOfUseId'
                                    value={wirelessChangeUserFormA.purposeOfUseId}
                                    disabled={wirelessChangeUserFormA.circuitId == 0}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={12} lg={12} className='required'>
                                <Select
                                    className="form-control"
                                    label={`${this.toLocaleLanguage('business_case')} `}
                                    options={businessCaseOptions}
                                    placeholder={this.toLocaleLanguage('select_placeholder')}
                                    fieldProp='.busJustiCodeDetailId'
                                    value={wirelessChangeUserFormA.busJustiCodeDetailId}
                                    disabled={wirelessChangeUserFormA.circuitId == 0}
                                    onChangeAction={this.businessCaseOnChange}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={12} lg={12} className='required placeholder-padding-textarea' >
                                <TextArea
                                    id={"wireless-c-u-busjus"}
                                    label={`${this.toLocaleLanguage('business_justification')}`}
                                    fieldProp='.businessJustification'
                                    value={wirelessChangeUserFormA.businessJustification}
                                    placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                                    disabled={wirelessChangeUserFormA.circuitId == 0 || this.state.businessCaseText.toLowerCase() != "other"}
                                    maxLength={MAX_LENGTH.limit_500}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={12} lg={12} className='placeholder-padding-textarea'>
                                <TextArea
                                    label={this.toLocaleLanguage('additional_information')}
                                    fieldProp='.additionalInformation'
                                    value={wirelessChangeUserFormA.additionalInformation}
                                    placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                                    disabled={wirelessChangeUserFormA.circuitId == 0}
                                    maxLength={MAX_LENGTH.limit_1000}
                                />
                            </Col>
                        </Row>
                        <div className="request-button-continer">
                            <div className="bottom-left">
                                <ORFButton
                                    label={this.toLocaleLanguage('modal_close_cancel_button')}
                                    variant={"light"}
                                    action={this.onClickCancel}
                                    type="button"
                                />
                            </div>
                            <div className="bottom-right">
                                <div>
                                    <ORFButton
                                        label={this.toLocaleLanguage('submit_request_button')}
                                        variant={"primary"}
                                        type={"submit"}
                                        disabled={isUpdateRequest ? (initialRequired || updateRequired) : initialRequired}
                                    />
                                </div>
                            </div>
                        </div>
                    </Form>
                </div>
        )
    }
};

export default withRouter (connect(
    state => {
        const { createRequest, wirelessChangeUserRequest, translation, requestDetail } = state;
        const { wirelessChangeUserFormA } = state.form;
        return {
            wirelessChangeUserFormA
            , createRequest
            , wirelessChangeUserRequest
            , ...translation
            , requestDetail
        };
    }
    , dispatch =>
        bindActionCreators(
            Object.assign({}
                , wirelessChangUserActions
                , createRequestActions
                , requestLogActions),
            dispatch
        )
)(MobileChangeUserForm));